import { Button, Grid, Typography } from "@mui/material"
import { KaziLayout } from "../../Shared Components/Kazi/Layouts/KaziLayout"
import { SyntheticEvent, useCallback, useEffect, useState } from "react"
import { PrivacyPolicy } from "./Components/Policies/PrivacyPolicy";
import { TermsOfService } from "./Components/Policies/TOS";
import { useParams, useNavigate } from "react-router-dom";

export const Policies = () => {
    /* ******************** Hooks ******************** */
    const { page } = useParams();
    const navigate = useNavigate();
    /* ******************** Variables ******************** */
    // @ts-ignore
    const [selected, setSelected ] = useState<'privacy' | 'terms'>(page ?? 'privacy');
    /* ******************** Functions ******************** */
    const handleClick = (params: any) => {
        const id = params.target.id;
        const btn = document.querySelector(`#${id}`);
        const currSelectedBtn = document.querySelector(`.selected`);
        if (btn) { 
            btn.classList.add('selected');
            setSelected(id);
            navigate({pathname: `/settings/policies/${id}`})
        }
        if (currSelectedBtn) {
            currSelectedBtn.classList.remove('selected');
        }
    }
    /* ******************** Effects ******************** */
    useEffect(()=>{
        const currSelectedBtn = document.querySelector(`.selected`)
        if (!currSelectedBtn) {
            const btn = document.querySelector(`#${page}`);
            if (btn) btn.classList.add('selected');
        }
    }, [])
    /* ******************** JSX ******************** */
    return (
        <KaziLayout>
            <Typography variant="lora-headline-small" >Policies</Typography>
            <Grid 
                display={'flex'} 
                flexDirection={'row'} 
                marginTop={'28px'} 
                marginBottom={2}
                gap={4}
                sx={{
                    '> .selected' : {
                        backgroundColor: 'green.100',
                        fontWeight: 'bold'
                    }
                }}
            >
                <Button variant="text" id="privacy" onClick={handleClick}>
                    Privacy Policy
                </Button>
                <Button variant="text" id="terms" onClick={handleClick}>
                    Terms of Service
                </Button>
            </Grid>
            <Grid
                display={'flex'}
                flexDirection={'column'}
            >
                {
                    selected == 'privacy' ?
                    <PrivacyPolicy /> :
                    <TermsOfService />
                }
            </Grid>
        </KaziLayout>
    )
}